export const sweetnessOptions = [
  {
    key: 1,
    text: "100%",
    value: 1,
  },
  {
    key: 2,
    text: "75%",
    value: 2,
  },
  {
    key: 3,
    text: "50%",
    value: 3,
  },
  {
    key: 4,
    text: "25%",
    value: 4,
  },
  {
    key: 5,
    text: "0%",
    value: 5,
  },
];
